export const fmtUSD = (n) =>
    (Number(n) || 0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtUSDShort = (n) => {
    const v = Number(n) || 0;
    if (Math.abs(v) >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M`;
    if (Math.abs(v) >= 1_000) return `$${(v / 1_000).toFixed(1)}k`;
    return fmtUSD(v);
};

export const fmtCarat = (n) => `${(Number(n) || 0).toFixed(2)} ct`;
export const fmtPct = (n) => `${(Number(n) || 0).toFixed(2)}%`;
export const fmtDate = (d) => {
    if (!d) return "—";
    try {
        return new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    } catch {
        return String(d);
    }
};

export const PARTNER_LABELS = { bashari: "Bashari", ido: "Ido" };
export const PARTNER_KEYS = ["bashari", "ido"];

export const SHAPES = [
    { value: "round", label: "Round", code: "RD" },
    { value: "pear", label: "Pear", code: "PS" },
    { value: "oval", label: "Oval", code: "OV" },
    { value: "princess", label: "Princess", code: "PR" },
    { value: "emerald", label: "Emerald", code: "EM" },
    { value: "marquise", label: "Marquise", code: "MQ" },
    { value: "cushion", label: "Cushion", code: "CU" },
    { value: "radiant", label: "Radiant", code: "RA" },
    { value: "heart", label: "Heart", code: "HT" },
    { value: "asscher", label: "Asscher", code: "AS" },
    { value: "baguette", label: "Baguette", code: "BG" },
    { value: "trillion", label: "Trillion", code: "TR" },
    { value: "other", label: "Other", code: "OT" },
];

export const PARCEL_STATUS_LABELS = {
    available: "Available",
    split: "Split",
    in_production: "In Production",
    set_in_jewelry: "Set In Jewelry",
    sold: "Sold",
};

export const JEWELRY_STATUS_LABELS = {
    in_production: "In Production",
    available: "Ready to sell",
    sold: "Sold",
};

export const JEWELRY_TYPES = [
    "Ring", "Necklace", "Bracelet", "Earrings", "Pendant", "Brooch", "Cufflinks", "Watch", "Other",
];

export const GOLD_KARATS = [10, 14, 18, 22, 24];
export const GOLD_COLORS = ["Yellow", "White", "Rose", "Two-tone", "Platinum"];

// Client-side code preview (matches backend formula). Serial is assigned by server on save.
const SHAPE_CODE_MAP = Object.fromEntries(SHAPES.map(s => [s.value, s.code]));
const clean = (s) => (s || "").toString().replace(/[\s\-\/]+/g, "").toUpperCase();
export const buildParcelCode = ({ shape, clarity, color, serial }) => {
    const sh = SHAPE_CODE_MAP[(shape || "other").toLowerCase()] || "OT";
    const cl = clean(clarity) || "NA";
    const co = clean(color) || "NA";
    const tail = serial ? `-${serial}` : "-##";
    return `${sh}-${cl}-${co}${tail}`;
};

export const computeSize = (carat, stones) => {
    const c = Number(carat);
    const s = Number(stones);
    if (!c || !s || s <= 0) return null;
    return +(c / s).toFixed(2);
};

export const fmtSize = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    const n = Number(v);
    if (!isFinite(n)) return "—";
    return `${n.toFixed(2)} ct`;
};
